import { render, staticRenderFns } from "./ListEmail.vue?vue&type=template&id=2c24bdd8"
import script from "./ListEmail.vue?vue&type=script&lang=js"
export * from "./ListEmail.vue?vue&type=script&lang=js"
import style0 from "./ListEmail.vue?vue&type=style&index=0&id=2c24bdd8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports